import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "edit-document-subject"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Voltar", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Crie um assunto de documento"),
  /*#__PURE__*/_createTextVNode(" (obrigatório)")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Dia de envio"),
  /*#__PURE__*/_createTextVNode(" (opcional)")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Dia limite para envio de documentos sobre esse assunto", -1)
const _hoisted_8 = { class: "slider" }
const _hoisted_9 = ["id", "checked", "onChange"]
const _hoisted_10 = ["for"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "13",
    height: "10",
    viewBox: "0 0 13 10",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_388_3128)" }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12.3047 2.42188C12.3047 2.63021 12.2318 2.80729 12.0859 2.95312L6.42969 8.60938L5.36719 9.67188C5.22135 9.81771 5.04427 9.89062 4.83594 9.89062C4.6276 9.89062 4.45052 9.81771 4.30469 9.67188L3.24219 8.60938L0.414062 5.78125C0.268229 5.63542 0.195312 5.45833 0.195312 5.25C0.195312 5.04167 0.268229 4.86458 0.414062 4.71875L1.47656 3.65625C1.6224 3.51042 1.79948 3.4375 2.00781 3.4375C2.21615 3.4375 2.39323 3.51042 2.53906 3.65625L4.83594 5.96094L9.96094 0.828125C10.1068 0.682292 10.2839 0.609375 10.4922 0.609375C10.7005 0.609375 10.8776 0.682292 11.0234 0.828125L12.0859 1.89062C12.2318 2.03646 12.3047 2.21354 12.3047 2.42188Z" })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_388_3128" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "12.5",
          height: "10",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_12 = { class: "spacing" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Status")
], -1)
const _hoisted_14 = {
  for: "stats",
  class: "switch"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_16 = ["disabled"]

import { computed, onMounted, ref, watch } from 'vue'
import { useAxios } from '@/api/axios'
import DocumentSubjectModel from '@/models/DocumentSubjectModel'
import { toast } from 'vue3-toastify'
import { AxiosResponse } from 'axios'
import DocumentSubjectStatusEnum from '@/enums/DocumentSubjectStatusEnum'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import { OrganizationModel } from '@/models/OrganizationModel'
import MyOptions from '@/components/options/MyOptions.vue'
import VueSlider from 'vue3-slider'
import MyDoubleRange from '@/components/range/MyDoubleRange.vue'
import { user } from '@/global/states/GlobalState'
import { TenantSectorEnum } from '@/enums/Tenants/TenantSectorEnum'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditDocumentSubjectView',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props
const axios = useAxios()
const isChamber = computed(() => user.value.tenant?.sector === TenantSectorEnum.CHAMBER)
const payload = ref<Partial<DocumentSubjectModel>>({})
const organizations = ref<OrganizationModel[]>()
const isUpdatingDocumentSubject = ref(false)

const updateValues = (value1: number, value2: number) => {
  if (value1 != 0 && value2 != 0) {
    payload.value.submission_start_day = value1
    payload.value.submission_start_end = value2
  } else if (value1 == 0 && value2 != 0) {
    payload.value.submission_start_day = 1
    payload.value.submission_start_end = value2
  } else if (value1 == 0 && value2 == 0) {
    payload.value.submission_start_day = undefined
    payload.value.submission_start_end = undefined
  }
}

function updateDocumentSubject () {
  isUpdatingDocumentSubject.value = true

  const payloadData = {
    document_subject_ids: [payload.value.id],
    name: payload.value.name,
    submission_start_day: payload.value.submission_start_day,
    submission_end_day: payload.value.submission_start_end,
    status: payload.value.status ? DocumentSubjectStatusEnum.ACTIVE : DocumentSubjectStatusEnum.INACTIVE,
    submission_date_exempt_organization_ids: payload.value.exempt_submission_date_organizations!.map((org) => org.id)
  }

  axios.put('/api/document-subjects', payloadData)
    .then(() => {
      toast.success('Assunto editado com sucesso')
    })
    .finally(() => isUpdatingDocumentSubject.value = false)
}

function getDocumentSubject () {
  axios.get(`/api/document-subjects/${props.id}`)
    .then((res: AxiosResponse<DocumentSubjectModel>) => {
      payload.value = { ...res.data, status: res.data.status == DocumentSubjectStatusEnum.ACTIVE }
    })

  console.log(payload.value)
}

function getOrganizations () {
  axios.get('/api/organizations')
    .then((res) => {
      organizations.value = res.data
    })
}

watch(() => payload.value.submission_end_day, (newValue) => {
  if (payload.value.submission_end_day <= payload.value.submission_start_day) {
    payload.value.submission_start_day = payload.value.submission_end_day - 1
  }
})

onMounted(() => {
  getDocumentSubject()
  getOrganizations()
})

return (_ctx: any,_cache: any) => {
  return (payload.value.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", {
          label: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
          class: "back"
        }, _hoisted_4),
        _createElementVNode("section", null, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Ex: Secretaria de Segurança e Trânsito",
            name: "name",
            id: "namet",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.name) = $event))
          }, null, 512), [
            [_vModelText, payload.value.name]
          ])
        ]),
        _createElementVNode("section", null, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(MyDoubleRange, {
              updateValues: updateValues,
              startValue: payload.value.submission_start_day,
              endValue: payload.value.submission_end_day
            }, null, 8, ["startValue", "endValue"])
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h1", null, [
            _createElementVNode("strong", null, _toDisplayString(isChamber.value ? 'Câmaras isentas' : 'Setores isentos'), 1),
            _createTextVNode(" (opcional)")
          ]),
          _createElementVNode("h2", null, "Quais " + _toDisplayString(isChamber.value ? 'câmaras' : 'setores') + " serão isentos de exceção(prazo de envio)?", 1),
          _createVNode(MyOptions, {
            currentValue: payload.value.exempt_submission_date_organizations?.length ? payload.value.exempt_submission_date_organizations.map(org => org.name).join(', ') : 'Selecione'
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, (org, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: index
                }, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: 'organization-' + index + 1,
                    name: "organizations",
                    checked: payload.value.exempt_submission_date_organizations?.find((o) => o.id == org.id) ? true : false,
                    onChange: ($event: any) => (($event.target as HTMLInputElement).checked ? payload.value.exempt_submission_date_organizations!.push(org) : payload.value.exempt_submission_date_organizations = payload.value.exempt_submission_date_organizations?.filter((o) => o.id != org.id))
                  }, null, 40, _hoisted_9),
                  _createElementVNode("label", {
                    for: 'organization-' + index + 1
                  }, [
                    _hoisted_11,
                    _createElementVNode("p", null, _toDisplayString(org.name), 1)
                  ], 8, _hoisted_10)
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["currentValue"])
        ]),
        _createElementVNode("section", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("label", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              name: "stats",
              id: "stats",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.status) = $event))
            }, null, 512), [
              [_vModelCheckbox, payload.value.status]
            ]),
            _hoisted_15
          ])
        ]),
        _createElementVNode("nav", null, [
          (!isUpdatingDocumentSubject.value)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "button",
                value: "Salvar",
                onClick: updateDocumentSubject,
                disabled: !payload.value.name
              }, null, 8, _hoisted_16))
            : (_openBlock(), _createBlock(SpinnerLoaderButton, {
                key: 1,
                height: 60,
                maxWidth: 464
              })),
          _createElementVNode("input", {
            type: "button",
            value: "Cancelar",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'admin.home' })))
          })
        ])
      ]))
    : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 }))
}
}

})